// Environment configuration for the frontend
const getEnvironmentConfig = () => {
  const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || (isServerEnvironment() ? '/api' : '/api'),
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || (isServerEnvironment() ? window.location.origin : window.location.origin),
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || (isServerEnvironment() ? window.location.origin : 'http://localhost:3000'),
    NODE_ENV: process.env.REACT_APP_NODE_ENV || 'development'
  };
  
  // Debug logging for URL configuration issues
  console.log('🌐 Environment Config Debug:', {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    port: window.location.port,
    origin: window.location.origin,
    href: window.location.href,
    config: config
  });
  
  return config;
};

// Export the configuration
export const environmentConfig = getEnvironmentConfig();

// Export individual values for convenience
export const API_BASE_URL = environmentConfig.API_BASE_URL;
export const BACKEND_URL = environmentConfig.BACKEND_URL;
export const FRONTEND_URL = environmentConfig.FRONTEND_URL;
export const NODE_ENV = environmentConfig.NODE_ENV;

// Function to update configuration
export const updateEnvironmentConfig = (newConfig) => {
  if (newConfig.API_BASE_URL) {
    localStorage.setItem('API_BASE_URL', newConfig.API_BASE_URL);
  }
  if (newConfig.BACKEND_URL) {
    localStorage.setItem('BACKEND_URL', newConfig.BACKEND_URL);
  }
  if (newConfig.FRONTEND_URL) {
    localStorage.setItem('FRONTEND_URL', newConfig.FRONTEND_URL);
  }
  
  // Update the exported values
  Object.assign(environmentConfig, newConfig);
};

// Function to get current server info
export const getServerInfo = () => {
  return {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    port: window.location.port,
    href: window.location.href,
    origin: window.location.origin
  };
};

// Function to check if running on server
export const isServerEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname !== 'localhost' && 
         hostname !== '127.0.0.1' && 
         !hostname.includes('localhost');
};

export default environmentConfig; 